import {
  REVENUE_DETAILS_SUCCESS,
  REVENUE_DETAILS_LOADING,
} from '../actions/revenueAction';

const initialState = {
  amazon: {
    revenueData: null,
    isLoading: true
  },
  shopify: {
    revenueData: null,
    isLoading: true
  },
  wholesale: {
    revenueData: null,
    isLoading: true
  },
};

const revenueReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REVENUE_DETAILS_SUCCESS:
      return {
        ...state, [action?.vendor]: { revenueData: action.data, isLoading: false }
      };
    case REVENUE_DETAILS_LOADING:
      return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };
    default:
      return state;
  }
};

export default revenueReducer;
